export type CategoryManagementRow = {
  category_total_expense: number;
  category_total_deposit?: number;
};

export const hasCategoryActivity = (category: CategoryManagementRow): boolean =>
  Number(category.category_total_expense ?? 0) !== 0 ||
  Number(category.category_total_deposit ?? 0) !== 0;
